/**
 * Created by mac on 2017/10/16.
 */
 import React from "react";
 import Waiting from "./Waiting";
 import Error2 from "./Error2";
 import ControlLabel from 'react-bootstrap/lib/ControlLabel';
 import FormGroup from 'react-bootstrap/lib/FormGroup'
 import FormControl from 'react-bootstrap/lib/FormControl'
 import {Form, Table, Button, Modal, Col} from "react-bootstrap";
 import ThePagination from "./Pagination";
 import * as api from "../api";
 import ElementView from "./ElementView";
 import DatePicker from "react-bootstrap-date-picker";

 
 export default class PromoInfoSum extends React.Component {
 
     constructor(props) {
         super(props);
         this.onLoad = this.onLoad.bind(this);
         this.state = {
             loading: false,
             error: null,
             page: 0,
             size: 10,
             total: 0,
             promos: [],
             editing: false,
             start_time: '',
             end_time: '',
             tel: '',
             status: '-1',
             _id: '',
             begin_time: '',
             over_time: ''
         }
     }
 
     onLoad() {
      const {page, size, tel, status, _id, start_time, end_time } = this.state;
      this.setState({loading: true, error: null});
      let params = {page, size, tel, status, _id, start_time, end_time }
      for (let key in params) {
          if (key !== 'page') {
            if (params[key] == '' || params[key] == -1) {
                delete params[key]
            }
          }
          if (key === 'start_time' || key === 'end_time') {
            if (params[key]) {
                params[key] = Math.floor(params[key]/1000)
            }
          }
      }
      api.getPayments(params)
          .then(json => {
            this.setState({
                loading: false,
                promos: json.data,
                total: json.total
            })
          })
          .catch(error => this.setState({
              loading: false,
              error: error
          }))
     }
     
     handleBeginChange = (newDate, formattedValue) => {
        this.setState({ begin_time: formattedValue });
        this.setState({ start_time: +new Date(newDate) });
        const {over_time} = this.state;
        this.setState({ beginTime: formattedValue });
        if (over_time) {
            if (formattedValue > over_time) {
                this.setState({ over_time: '' });
                this.setState({ end_time: '' });
            } else {
                this.setState({ beginTime: formattedValue });
                this.setState({ start_time: +new Date(newDate) });
            }
        }
        
    };

    handleEndChange = (value, formattedValue) => {
        const {begin_time} = this.state;
        if (!begin_time) {
            return this.setState({ error: '请先填写开始时间' })
        }
        if (formattedValue < begin_time) {
            return this.setState({error: '结束时间必须大于开始时间'})
        }
        this.setState({ over_time: formattedValue });
        this.setState({ end_time: +new Date(value) });
    };
 
     componentDidMount() {
         this.onLoad();
     }
 
     render() {
         const {begin_time, over_time, loading, error, promos, page, size, total, tel, status, _id} = this.state;
         const format = "YYYY-MM-DD";
         const dayLabels= ['日', '一', '二', '三', '四', '五', '六']
         const monthLabels= ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
         const statusInfo = {9: '已完成', 0: '未付款'}
         return (
             <div style={{marginTop: 5}}>
                 <Waiting isVisible={loading}/>
                 <Error2 error={error} onOk={() => this.setState({error: null})}/>
                 <Form inline style={{padding: 3, marginTop: 10}}>
                     <ControlLabel>用户手机号:</ControlLabel>
                     &nbsp;
                     <FormControl
                         bsSize="sm" value={tel} placeholder="请输入关键字"
                         onChange={e => this.setState({page: 0, tel: e.target.value.trim()})}>
                     </FormControl>
                     &nbsp;
                     <ControlLabel>订单编号:</ControlLabel>
                     &nbsp;
                     <FormControl
                         bsSize="sm" value={_id} placeholder="请输入准确号段"
                         onChange={e => this.setState({page: 0, _id: e.target.value.trim()})}>
                     </FormControl>
                     &nbsp;
                     <ControlLabel>订单状态：</ControlLabel>
                        <FormControl componentClass="select" value={status}
                            onChange={e => this.setState({status: e.target.value})}>
                            <option value="-1">全部</option>
                            <option value="0">未付款</option>
                            <option value="9">已完成</option>
                        </FormControl>
                    &nbsp;
                     <ControlLabel>起始日期</ControlLabel>
                     &nbsp;
                     <DatePicker
                         value={begin_time}
                         dateFormat={format}
                         dayLabels={dayLabels}
                         monthLabels={monthLabels}
                         placeholder="请输入开始时间"
                         onChange={this.handleBeginChange}/>
                     &nbsp;
                     <ControlLabel>结束日期</ControlLabel>
                     &nbsp;
                     <DatePicker
                         value={over_time}
                         dateFormat={format}
                         dayLabels={dayLabels}
                         monthLabels={monthLabels}
                         placeholder="请输入结束时间"
                         onChange={this.handleEndChange}/>
                    <button className="btn btn-success btn-sm" style={{ marginLeft: 15 }} onClick={e => {
                        e.preventDefault();
                        this.onLoad();
                    }}>搜索
                    </button>
                 </Form>
 
                 <br/>
                

                 <Table bordered hover striped condensed responsive>
                     <thead>
                     <tr>
                         <th>订单编号</th>
                         <th>订单金额</th>
                         <th>支付时间</th>
                         <th>支付方式</th>
                         <th>收货人</th>
                         <th>状态</th>
                         <th>封面</th>
                         <th>名称</th>
                         <th>单价</th>
                         <th>规格</th>
                     </tr>
                     </thead>
                     <tbody>
                     {
                         promos.map((info, index) => {
                             return (
                                 <tr key={index}>
                                     <td>{info._id}</td>
                                     <td>{(info.amount/100).toFixed(2)}</td>
                                     <td>{info.time_paid ? <ElementView type="timestamp" value={info.time_paid}/> : ''}</td>
                                     <td>{info.channel}</td>
                                     <td>{info.tel}</td>
                                     <td>{statusInfo[info.status]}</td>
                                     <td><img src={info.cover_url} alt="" style={{ width: 100 }}/></td>
                                     {/* <td>{info.time_paid ? <ElementView type="image" value={info.cover_url}/> : ''}</td> */}
                                     <td>{info.goods_name}</td>
                                     <td>{(info.price/100).toFixed(2)}</td>
                                     <td>{info.sku}</td>
                                 </tr>
                             )
                         })
                     }
                     </tbody>
                 </Table>
                 <ThePagination page={page} size={size} total={total}
                               onSelect={page => this.setState({page}, this.onLoad)}/>
             </div>
         );
     }
 }
 


// WEBPACK FOOTER //
// src/components/OrderList.js